import React, { useMemo } from 'react';
import axios from 'axios';
import config from '../../../../config';
import TransferList from '../shared/TransferList';

/**
 * Revenue-share-method assignment for the current concessionaire.
 * Thin adapter over the generic <TransferList/>.
 */
const RevenuMethodAdd = () => {
    const adapter = useMemo(() => {
        const concessionaire_id = localStorage.getItem('concessionaireId');
        const login_id = localStorage.getItem('loginId');
        const headers = { Authorization: `${localStorage.getItem('sessiontoken')}` };

        return {
            loadCatalog: async () => {
                try {
                    const res = await axios.get(`${config.hostname}/revenuemethods/getrevenuemethods`, { headers });
                    return (res.data || []).map((m) => ({ id: m._id, label: m.description }));
                } catch (err) {
                    if (err?.response?.status === 404) return [];
                    throw err;
                }
            },
            loadAssigned: async () => {
                try {
                    const res = await axios.post(
                        `${config.hostname}/concessionairerevenuemethods/getmethods`,
                        { concessionaire_id },
                        { headers },
                    );
                    // Backend 404s (not empty array) when none are assigned.
                    return (res.data || [])
                        .filter((m) => m.revenue_method_id)
                        .map((m) => ({
                            id: m.revenue_method_id._id,
                            label: m.revenue_method_id.description,
                        }));
                } catch (err) {
                    if (err?.response?.status === 404) return [];
                    throw err;
                }
            },
            assign: (items) =>
                axios.post(
                    `${config.hostname}/concessionairerevenuemethods/createmethod`,
                    { concessionaire_id, revenue_method_id: items.map((i) => i.id), login_id },
                    { headers },
                ),
            unassign: (ids) =>
                axios({
                    method: 'delete',
                    url: `${config.hostname}/concessionairerevenuemethods/removemethod`,
                    data: { concessionaire_id, revenue_method_id: ids, login_id },
                    headers,
                }),
        };
    }, []);

    return (
        <TransferList
            adapter={adapter}
            availableTitle="Available revenue-share methods"
            assignedTitle="Assigned methods"
            searchPlaceholder="Search methods…"
        />
    );
};

export default RevenuMethodAdd;
